import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

// Ce composant est une encapsulation pour le composant NgxMatTimepicker afin de pouvoir retoucher son style
@Component({
	selector: 'basic-timepicker',
	templateUrl: 'basic-timepicker.html',
	styleUrls: ['basic-timepicker.css'],
	// Cet indicateur informe qu'il ne faudra pas encapsuler les styles de basic-timepicker.css afin qu'ils s'appliquent au NgxMatTimepicker
	encapsulation: ViewEncapsulation.None
})
export class BasicTimepickerComponent {
	@Input() time!: Date;
	
	@Output() timeChange = new EventEmitter<Date>();
	
	constructor( //
	) {
	}
	
	onTimeChange(time: Date) {
		this.timeChange.emit(time);
	}
}